import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import logo from '../assets/logo.png';

const EMPRESA = {
  direccion: 'Avda. de España nº 121',
  localidad:  '41.700 Dos Hermanas',
  telefono:   'Tlf. 955 662 663  Movil. 659 712 480',
  email:      'e-mail: mondepin@mondepin.es',
};

const s = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 8,
    color: '#111',
    paddingTop: 24,
    paddingBottom: 36,
    paddingHorizontal: 28,
  },

  // ── Cabecera ──
  header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 },
  logoCol: { flexDirection: 'column', gap: 2 },
  logo: { width: 110, height: 41, marginBottom: 4 },
  empresaTxt: { fontSize: 7, color: '#333', lineHeight: 1.4 },
  titulo: { fontSize: 16, fontFamily: 'Helvetica-Bold', textAlign: 'center', marginTop: 8 },

  // ── Tabla ──
  table: { marginTop: 8 },
  tableRow: { flexDirection: 'row', borderLeftWidth: 0.5, borderLeftColor: '#000' },
  cell: {
    borderRightWidth: 0.5, borderRightColor: '#000',
    borderBottomWidth: 0.5, borderBottomColor: '#000',
    paddingVertical: 2.5,
    paddingHorizontal: 3,
  },
  tableHead: { flexDirection: 'row', borderLeftWidth: 0.5, borderLeftColor: '#000', borderTopWidth: 0.5, borderTopColor: '#000' },
  thCell: {
    borderRightWidth: 0.5, borderRightColor: '#000',
    borderBottomWidth: 0.5, borderBottomColor: '#000',
    paddingVertical: 3,
    paddingHorizontal: 3,
    fontFamily: 'Helvetica-Bold',
    fontSize: 7.5,
  },

  // Columnas
  colSin:  { width: '22%' },
  colDom:  { width: '44%' },
  colFec:  { width: '13%', textAlign: 'center' },
  colImp:  { width: '10.5%', textAlign: 'right' },
  colTot:  { width: '10.5%', textAlign: 'right' },

  // ── Totales ──
  totalesBox: { marginTop: 10, alignItems: 'flex-end' },
  totRow: { flexDirection: 'row', justifyContent: 'space-between', width: 180, paddingVertical: 2 },
  totLabel: { fontSize: 8, fontFamily: 'Helvetica-Bold' },
  totValor: { fontSize: 8, fontFamily: 'Helvetica-Bold' },

  // ── Pie ──
  footer: {
    position: 'absolute', bottom: 14, left: 28, right: 28,
    flexDirection: 'row', justifyContent: 'flex-end',
  },
  footerText: { fontSize: 6.5, color: '#666' },
});

const fmt = (v) =>
  Number(v ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

const fmtF = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export default function InformeSiniestrosPdf({ siniestros, titulo, subtitulo }) {
  const importeTotal = siniestros.reduce((a, r) => a + Number(r.importe ?? 0), 0);
  const ivaTotal     = siniestros.reduce((a, r) => a + Number(r.iva     ?? 0), 0);
  const totalTotal   = siniestros.reduce((a, r) => a + Number(r.total   ?? 0), 0);

  return (
    <Document title="Informe de Siniestros — Mondepin">
      <Page size="A4" orientation="portrait" style={s.page}>

        {/* ── Cabecera ── */}
        <View style={s.header}>
          <View style={s.logoCol}>
            <Image src={logo} style={s.logo} />
            <Text style={s.empresaTxt}>{EMPRESA.direccion}</Text>
            <Text style={s.empresaTxt}>{EMPRESA.localidad}</Text>
            <Text style={s.empresaTxt}>{EMPRESA.telefono}</Text>
            <Text style={s.empresaTxt}>{EMPRESA.email}</Text>
          </View>
          <View style={{ flex: 1, paddingLeft: 20 }}>
            <Text style={s.titulo}>INFORME DE SINIESTROS ACOTADO</Text>
          </View>
        </View>

        {/* ── Cabecera tabla ── */}
        <View style={s.table}>
          <View style={s.tableHead}>
            <Text style={[s.thCell, s.colSin]}>Siniestro</Text>
            <Text style={[s.thCell, s.colDom]}>Domicilio</Text>
            <Text style={[s.thCell, s.colFec]}>Fecha</Text>
            <Text style={[s.thCell, s.colImp]}>Importe</Text>
            <Text style={[s.thCell, s.colTot]}>Total</Text>
          </View>

          {/* ── Filas ── */}
          {siniestros.map((r) => (
            <View key={r.id} style={s.tableRow} wrap={false}>
              <Text style={[s.cell, s.colSin]}>{r.nSiniestro || `#${r.id}`}{r.extension > 1 ? ` Ext.${r.extension}` : ''}</Text>
              <Text style={[s.cell, s.colDom]}>{r.domicilio}</Text>
              <Text style={[s.cell, s.colFec]}>{fmtF(r.fechaFacturado)}</Text>
              <Text style={[s.cell, s.colImp]}>{fmt(r.importe)}</Text>
              <Text style={[s.cell, s.colTot]}>{fmt(r.total)}</Text>
            </View>
          ))}
        </View>

        {/* ── Totales ── */}
        <View style={s.totalesBox}>
          <View style={s.totRow}>
            <Text style={s.totLabel}>TOTAL IMPORTE</Text>
            <Text style={s.totValor}>{fmt(importeTotal)}</Text>
          </View>
          <View style={s.totRow}>
            <Text style={s.totLabel}>IVA</Text>
            <Text style={s.totValor}>{fmt(ivaTotal)}</Text>
          </View>
          <View style={s.totRow}>
            <Text style={s.totLabel}>TOTAL CANTIDAD</Text>
            <Text style={s.totValor}>{fmt(totalTotal)}</Text>
          </View>
        </View>

        {/* ── Pie ── */}
        <View style={s.footer} fixed>
          <Text style={s.footerText} render={({ pageNumber, totalPages }) =>
            `Página ${pageNumber} de ${totalPages}`
          } />
        </View>

      </Page>
    </Document>
  );
}
